// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hex-input-wrapper {
  position: relative;
  border-radius: 3px;
  border: 1px solid rgb(240, 240, 240);
  overflow: hidden;
}
.hex-input-wrapper label {
  margin: unset;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 25px;
  background-color: rgb(240, 240, 240);
  display: grid;
  place-content: center;
  font-size: 1.4rem;
  font-weight: 300;
  color: rgb(159, 166, 168) !important;
}
.hex-input-wrapper input.hex-input {
  position: absolute;
  left: 25px;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: unset;
  border: none;
  padding-inline: 6px;
  text-transform: uppercase;
  color: rgb(102, 102, 102);
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/ColorPicker/HexInput.scss"],"names":[],"mappings":"AAAA;EAIE,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;AAFF;AAIE;EACE,aAAA;EAEA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,WAfW;EAgBX,oCAfK;EAgBL,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;AAHJ;AAME;EACE,kBAAA;EACA,UA1BW;EA2BX,MAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AAJJ","sourcesContent":[".hex-input-wrapper {\n  $labelWidth: 25px;\n  $gray: rgb(240, 240, 240);\n\n  position: relative;\n  border-radius: 3px;\n  border: 1px solid $gray;\n  overflow: hidden;\n\n  label {\n    margin: unset;\n\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: $labelWidth;\n    background-color: $gray;\n    display: grid;\n    place-content: center;\n    font-size: 1.4rem;\n    font-weight: 300;\n    color: rgb(159, 166, 168) !important;\n  }\n\n  input.hex-input {\n    position: absolute;\n    left: $labelWidth;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: unset;\n    border: none;\n    padding-inline: 6px;\n    text-transform: uppercase;\n    color: rgb(102, 102, 102);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
